"use client";

import { OrgSwitcher } from "@/components/OrgSwitcher/OrgSwitcher";

interface UserDropdownProps {
  isCollapsed: boolean;
}

export const UserDropdown = ({ isCollapsed }: UserDropdownProps) => {
  return <OrgSwitcher isCollapsed={isCollapsed} />;
};
